// ════════════════════════════════════════════════════════════════════════
//  Rahmen um alles, was an EINEM Lehrgang arbeitet
//
//  Vorher standen Grundeinstellungen, Lektionen und Releases als drei
//  gleichrangige Bereiche im Kopf – neben Schulen, mit dem sie nichts zu tun
//  haben. Das zeigte den Schnitt durchs Datenmodell, nicht die Aufgabe: alle
//  drei arbeiten an EINEM Entwurf, und dass sie es tun, musste die Anleitung
//  erklären.
//
//  Jetzt erklärt es der Rahmen. Neu daran ist nur, welcher Lehrgang gemeint ist:
//  er steht in der Adresse, und der Entwurfszustand hängt an ihm. Der `key` auf
//  dem Provider ist kein Kunstgriff, sondern die Aussage: ein anderer Lehrgang
//  ist ein anderer Vorgang, und was im vorigen offen war, gehört nicht hierher.
// ════════════════════════════════════════════════════════════════════════

import { Link, Outlet } from "react-router-dom";
import { useSession } from "@otto/plattform";
import { DraftProvider } from "../../../shared/context/DraftContext.js";
import { COURSES, useCourseSlug } from "../../../shared/lib/coursePath.js";
import { curriculumBySlug, useCurricula } from "../../curricula/lib/data.js";
import { VersionBar } from "./VersionBar.js";
import styles from "../../../shared/components/shell.module.css";

export function CourseLayout() {
  const slug = useCourseSlug();
  const { client } = useSession();
  const curricula = useCurricula(client);
  const curriculum = curriculumBySlug(curricula.data, slug);

  if (curriculum === null) {
    return (
      <div className={styles.card}>
        <h1 className={styles.title}>Diesen Lehrgang gibt es nicht</h1>
        <p className={styles.subtitle}>
          Die Adresse nennt „{slug}“. Vielleicht ist ein Lesezeichen veraltet.{" "}
          <Link to={COURSES}>Zur Liste der Lehrgänge</Link>
        </p>
      </div>
    );
  }

  return (
    <DraftProvider key={slug} curriculum={curriculum ?? null}>
      {/* Immer, nicht nur mit Entwurf: ohne einen sagt sie, welche Fassung man
          gerade liest und dass sie unveränderlich ist. Genau diese Auskunft
          fehlte, als es hier stattdessen „Kein Entwurf offen“ hieß. */}
      <VersionBar title={curriculum?.title ?? ""} />
      <Outlet />
    </DraftProvider>
  );
}
